/**
 * Bajadas que NO se cortan a mitad de palabra.
 *
 * El patrón anterior (`slice(0,180) + "…"` o `line-clamp` de CSS) dejaba cosas como
 * "…vas a entender lo esencial, crea…": el texto queda mutilado y encima, en el detalle
 * de curso, la descripción completa aparece igual más abajo en "Sobre este curso". Un
 * resumen mutilado no aporta nada que el texto completo no diga mejor.
 *
 * Acá se corta por ORACIONES completas: se acumulan frases hasta el límite y se devuelve
 * lo que entró entero. Si ni la primera frase entra, recién ahí se recorta por palabra
 * (nunca por carácter suelto).
 */

/** Quita etiquetas HTML y normaliza espacios. La descripción viene como HTML del admin. */
export function toPlainText(html: string | undefined | null): string {
  if (!html) return "";
  return html
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Devuelve las primeras oraciones completas que entren en `maxLength`.
 * Sin puntos suspensivos: lo que se muestra siempre termina donde termina una idea.
 */
export function leadSentences(text: string, maxLength = 180): string {
  const clean = toPlainText(text);
  if (!clean) return "";
  if (clean.length <= maxLength) return clean;

  // Cortes de oración: . ! ? … seguidos de espacio (o fin). Se conserva el signo.
  const sentences = clean.match(/[^.!?…]+[.!?…]+(\s|$)|[^.!?…]+$/g) ?? [clean];
  let out = "";
  for (const s of sentences) {
    const next = (out + s).trimEnd();
    if (next.length > maxLength) break;
    out = next + " ";
  }
  out = out.trim();
  if (out) return out;

  // Ni la primera oración entra: se corta por palabra y se cierra con puntos suspensivos.
  const cut = clean.slice(0, maxLength);
  const lastSpace = cut.lastIndexOf(" ");
  return (lastSpace > maxLength * 0.6 ? cut.slice(0, lastSpace) : cut).trimEnd() + "…";
}
